import { getStep } from '@state/features/accordion.selectors';
import { AccordionStepsActionTypes, ConnectivityActionTypes } from '@state/features/common.types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Config from '@config';
import ConnectivityCheckoutPage from './ConnectivityCheckoutPage';
const ConnectivityCheckoutWrapper = (props) => {
    const dispatch = useDispatch();
    const { product } = useSelector((state) => state.connectivity);
    const step = useSelector(getStep);
    const connectivitySteps = Config.connectivitySteps;
    useEffect(() => {
        dispatch({ type: ConnectivityActionTypes.FETCH_CONNECTIVITYDATA });
    }, []);
    useEffect(() => {
        if (product && (!step || !connectivitySteps.includes(step))) {
            let stepSelector = 'personalData';
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: stepSelector });
            return;
        }
    }, [product, step]);
    if (!product) {
        return React.createElement(React.Fragment, null);
    }
    else {
        return React.createElement(ConnectivityCheckoutPage, Object.assign({}, props));
    }
};
export default ConnectivityCheckoutWrapper;
